import _ from 'underscore';
import getConfig from 'next/config';
import { logError } from '../logger';
import api, { prepareQueryParams } from './api';
import RequestPromise from './RequestPromise';

const { publicRuntimeConfig } = getConfig();

const getRequestParams = (data) =>
	data instanceof RequestPromise ? data.request : data;

const batchRequest = async (requestParams, params = {}) => {
	const requests = _(requestParams)
		.chain()
		.map((data, id) => (data ? { ...getRequestParams(data), id } : null))
		.compact()
		.map(({ query, ...request }) => ({
			query: prepareQueryParams(query),
			...request
		}))
		.value();

	const mergedParams = _(requestParams)
		.chain()
		.filter((request) => request instanceof RequestPromise)
		.pluck('params')
		.reduce((acc, value) => ({ ...acc, ...value }))
		.extend(params)
		.value();

	const responses = await api('batch', { requests }, 'POST', mergedParams);
	const isLog = publicRuntimeConfig.requestLogLevel !== 'none';

	const results = [];
	responses.forEach(({ id, statusCode, result }, index) => {
		if (statusCode >= 400) {
			const error = result && result.error;
			const message = `${statusCode} ${error || result}`;

			const err = new Error(`Response status from server: ${message}`);
			err.statusCode = statusCode;

			if (isLog) {
				const { method = 'GET', path } = requests[index];
				logError(
					`${method} ${path}: error occured during batch request: ${message}`
				);
			}

			throw err;
		}

		results[id] = result;
	});

	return results;
};

export default batchRequest;
